<template>
  <router-link class="no-underline" :to="permalink">
    <card class="card" has-outline>
      <template v-slot:title>{{name}}</template>
      <template>
        <date-string :timestamp="startDate" />
        <span>&nbsp; — &nbsp;</span>
        <date-string :timestamp="endDate" />
    </template>
    </card>
  </router-link>
</template>


<script>
import Card from '@/components/Card.vue';
import DateString from '@/components/DateString.vue';

export default {
  name: 'SeasonCard',
  components: {
    Card,
    DateString,
  },
  props: {
    id: String,
    name: String,
    startDate: Object,
    endDate: Object,
  },
  computed: {
    permalink() {
      return {
        name: 'EditSeason',
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>
